export default "__VITE_ASSET__CVCPcjyP__"